import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailCaptcha.css';
import './BXmakerAuthuseremailLoader';
import './BXmakerAuthuseremailInput';
import './BXmakerAuthuseremailRefresh';

/**
 * @emits onComplete {} - когда нажата кнопка Enter или когда введено ожидаемое количество символов
 * @emits onInput {value} - ввод символов
 * @emits onClickRefresh {} - клик по кнопке перезагрузить
 */
Vue.component('BXmakerAuthuseremailCaptcha',
    {
        props:{
            'src' : { type: [String, Boolean] },
            'word': { type: [String, Boolean] },
            'length': { type:Number },
            'loader': { type: [String, Boolean] },
        },
        data: function () {
            return {
                code: '',
            };
        },
        methods: {
            onEnter() {
                this.$emit('onComplete');
            },
            onInput(value) {
                this.$emit('onInput', value);
                if(value.length == this.length)
                {
                    this.onEnter();
                }
            },
            onClickRefresh(){
                this.$emit('onClickRefresh');
            }
        },
        template: `
            <div class="bxmaker-authuseremail-captcha" 
                :class="{'bxmaker-authuseremail-captcha--loading' : loader}" 
                v-if="src"  >
                 <div class="bxmaker-authuseremail-captcha__img ">
                    <BXmakerAuthuseremailRefresh @onClick="onClickRefresh" />
                    <BXmakerAuthuseremailLoader v-if="loader" />  
                    <img :src="src"  />                             
                 </div>                 
                 <div class="bxmaker-authuseremail-captcha__input">
                       <BXmakerAuthuseremailInput  :title="$root.localize.BXMAKER_AUTHUSEREMAIL_CAPTCHA_INPUT_TITLE" 
                       :value="word" 
                       :maxLength="length"
                       @onInput="onInput"
                       @onEnter="onEnter"
                       />            
                </div>
            </div>
        `,
    });